import { fetcher } from "helpers/fetcher";

import { TGetAccessRightPresetReq, TGetAccessRightPresetRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getAccessRightPreset = async (
  payload?: TGetAccessRightPresetReq
) => {
  return await fetcher<
    TGetAccessRightPresetRes,
    TGetAccessRightPresetReq["data"]
  >(ENDPOINT.MANAGEMENT.GET_ACCESS_RIGHT_PRESET, {
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.MANAGEMENT.GET_ACCESS_RIGHT_PRESET.version,
      [API_HEADER.BU_ID]: payload?.idBu,
    },
    data: payload?.data,
  });
};

export const queryGetAccessRightPreset = async (
  payload?: TGetAccessRightPresetReq
) => {
  return (await getAccessRightPreset(payload)).data;
};

queryGetAccessRightPreset._key = (payload?: TGetAccessRightPresetReq) => [
  ENDPOINT.MANAGEMENT.GET_ACCESS_RIGHT_PRESET.url,
  payload,
];
